























import Vue from "vue";
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import { ICustTypeDto } from "../../../interfaces";
import { makeCustType } from "../../../utils";
// import axios from "axios";
// import * as CL from "../Mtc_classes";
// import { MtcADMIN } from "../Mtc";
// import AdminTemplate from "../../../dev/Components/AdminTemplate.vue";
// import AdminTitles from "../../../dev/Components/AdminTitles.vue";

@Component({
  components: {}
})
export default class CustomerTypeEditor extends Vue {
  constructor() {
    super();
  }

  /* LIFECYCLE METHODS */
  mounted() {
    this.custTypes = this.$store.getters["AppModule/custTypes"];
  }
  // created(){}

  /* PROPS VARIABLES, They have to be lower case, or first capital only, 
		otherwise they will fail ! */
  @Prop()
  public value!: ICustTypeDto;

  @Prop()
  public rules: any;

  /* PRIVATE VARIABLES, __ POSTFIXED */
  // private myVar__: any;

  /* VUE DATA */
  public custTypes: ICustTypeDto[] = [];
  public tmpCustType: string = "";

  /* VUE WATCH */
  @Watch("value", { immediate: true })
  onValueChanged(newVal: ICustTypeDto, oldVal: ICustTypeDto) {
    if (newVal == null) return;
    this.tmpCustType = newVal.Name;
  }

  @Watch("tmpCustType")
  onTmpValueChanged(newVal: any, oldVal: any) {
    if (newVal == null) return;
    /*
		WHEN THE CUSTOMER TYPE IS UPDATED, 
		WE ARE LOOKING FOR THE CUST-TYPE OBJECT AND ASSIGN IT
		TO OUR "PSEUDO MODEL" cust OBJECT
		*/
    var found = this.custTypes.find(f => {
      return f.Name == newVal;
    });
    this.$emit("input", found);
  }

  /* VUE COMPUTED METHODS */
  // get date(): Date {
  //   return new Date();
  // }

  /* PRIVATE METHODS */
  // private MyFunction():void{}

  /* VUE METHODS */
  // public DoNothing():void{}
}
